import { render } from "./DashboardRecepcionista.vue?vue&type=template&id=006cbf34"
import script from "./DashboardRecepcionista.vue?vue&type=script&lang=js"
export * from "./DashboardRecepcionista.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__